import { default as config } from "common/config/config";
import type { PartnerDto } from "common/models/api/models/PartnerDto";
import { useRef } from "react";
import { FormScaffoldProps } from "ui/common/components/layout/FormScaffold/FormScaffold.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import { PartnerFormGridNames } from "../PartnerFormGrid.types";

export default function usePartnerFormGridRows() {
    const translate = useTranslate();

    const rows = useRef([
        [
            {
                label: translate("logo"),
                input: "image",
                alt: "program-logo",
                name: PartnerFormGridNames.LOGO,
                required: false,
            },
            {
                label: translate("name"),
                input: "textfield",
                required: true,
                name: PartnerFormGridNames.NAME,
                bold: true,
            },
            {
                label: translate("description"),
                input: "textarea",
                maxLength: config.validators.program.maxProgramDescriptionLength,
                required: false,
                name: PartnerFormGridNames.DESCRIPTION,
            },
            {
                label: translate("link"),
                input: "textfield",
                maxLength: config.validators.maxUrlLength,
                validators: { url: true },
                name: PartnerFormGridNames.LINK,
            },
            {
                label: translate("location"),
                input: "textfield",
                name: PartnerFormGridNames.LOCATION,
            },
            {
                label: translate("automaticRedemption"),
                input: "textfield",
                name: PartnerFormGridNames.SCHEDULED_REDEEM,
                viewOnly: true,
                bold: true,
            },
        ],
    ]).current as FormScaffoldProps<PartnerDto>["rows"];
    return rows;
}
